exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-gray[data-v-26690672] {\n  background: #e5e9eccc;\n}\n.bg-yellow[data-v-26690672] {\n  background: #ffff31cc !important;\n}\n.table > tbody > tr > td[data-v-26690672] {\n  border: 1px solid #e8edf1;\n}\n", ""]);

// exports
